export default "__VITE_ASSET__a9375bf3__"